export default __webpack_public_path__ + "static/media/Fingerprint-bro.5d4ccbb9.svg";